import { render, staticRenderFns } from "./CollapseContent.vue?vue&type=template&id=7f1458bc&scoped=true&"
import script from "./CollapseContent.vue?vue&type=script&lang=js&"
export * from "./CollapseContent.vue?vue&type=script&lang=js&"
import style0 from "./CollapseContent.vue?vue&type=style&index=0&id=7f1458bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1458bc",
  null
  
)

export default component.exports